import React from "react";
import { GET, DELETE } from "Common/api";
import config from "lib/config";
import LuvitComponent from "LuvitComponent";
import Notifier from "lib/components/notifier";
import ButtonUnderlined from "Components/Fragment/ButtonUnderlined";
import { IconButton, SingleaddButton } from "lib/components/Button";
import AddActivity from "domains/talentmanagement/coworker/goals/addactivity.jsx";
import SettingStore from "stores/settings";
import { observer } from "mobx-react";
import { isStandardActivityType } from "lib/utils";
import EducationHistoryDetailDialog from "./EducationHistoryDetailDialog";

const EDITABLE_ACTIVITY_TYPES = [
  "otheractivity",
  "externalcourse",
  "commonactivity",
];

const DETAIL_VIEW_ACTIVITY_TYPES = [
  "onlinecourse",
  "instructorledtraining",
  "program",
];

@observer
export default class EducationHistory extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "TalentManagement");
  }

  async componentWillMount() {
    let courses = await GET("/v1/user/:personalId/educationHistory", {
      personalId: this.props.personalId,
    });
    courses = Array.isArray(courses) ? courses : [];

    let allowUsersToCompleteCourses = SettingStore.getSettingValue(
      "allowusertocompletecourses",
    );

    let allowUsersToCompleteActivities = SettingStore.getSettingValue(
      "allowusertocompleteactivities",
    );

    let hideOtherActivitiesInEducationHistory = SettingStore.getSettingValue(
      "hideotheractivitiesineducationhistory",
    );

    const hideAddCompletedCoursesInEducationHistory =
      SettingStore.getSettingValue("hideaddcompletedcoursesineducationhistory");

    let installationId = await GET("v1/adminsettings/:settingName", {
      settingName: "installationid",
    });

    let res = await GET("v1/adminsettings/:settingName", {
      settingName: "cvMetadataColumns",
    });

    let activeConfig;
    if (res) activeConfig = res.split(",");

    this.setState({
      ready: true,
      courses,
      sortOrderCourses: "desc",
      sortByCourses: "endDate",
      allowUsersToCompleteCourses,
      allowUsersToCompleteActivities,
      hideOtherActivitiesInEducationHistory,
      hideAddCompletedCoursesInEducationHistory,
      activeConfig,
      installationId,
    });
  }

  async onRefresh() {
    let courses = await GET("/v1/user/:personalId/educationHistory", {
      personalId: this.props.personalId,
    });
    courses = Array.isArray(courses) ? courses : [];

    this.setState({ ready: true, courses });
  }

  getNormalizedCourseType(course) {
    const t = course && course.type;
    return typeof t === "string" ? t.toLowerCase() : t;
  }

  async deleteActivity(course) {
    if (confirm(`${this.l("confirmdeleteitem")} ${course.title} ?`)) {
      await DELETE(`/v1/coworker/externalcourse?courseId=${course.id}`);
      this.onRefresh();
    }
  }

  sortCourses(sortBy) {
    if (this.props.printMode) return;
    const stateCourses = this.state.courses;
    if (!Array.isArray(stateCourses)) return;

    var sortOrder = "desc";

    if (this.state.sortByCourses === sortBy) {
      if (this.state.sortOrderCourses === "asc") sortOrder = "desc";
      else sortOrder = "asc";
    } else {
      sortOrder = "asc";
    }

    const courses = [...stateCourses].sort((a, b) => {
      if (sortOrder === "asc") {
        return a[sortBy] < b[sortBy] ? -1 : 1;
      }
      return a[sortBy] < b[sortBy] ? 1 : -1;
    });

    this.setState({
      courses,
      sortByCourses: sortBy,
      sortOrderCourses: sortOrder,
    });
  }

  openDialog() {
    this.setState({ activityEdit: {} });
  }

  resetEditActivity() {
    this.setState({ activityEdit: null });
  }

  resetDetailCourse() {
    this.setState({ detailCourse: null });
  }

  isEditableActivityType(normalizedType) {
    return EDITABLE_ACTIVITY_TYPES.includes(normalizedType);
  }

  isDetailViewActivityType(normalizedType) {
    return DETAIL_VIEW_ACTIVITY_TYPES.includes(normalizedType);
  }

  isClickableActivityType(normalizedType) {
    return (
      this.isEditableActivityType(normalizedType) ||
      this.isDetailViewActivityType(normalizedType)
    );
  }

  openCourse(course) {
    const normalizedType = this.getNormalizedCourseType(course);
    if (this.isEditableActivityType(normalizedType)) {
      this.setState({ activityEdit: course, detailCourse: null });
    } else if (this.isDetailViewActivityType(normalizedType)) {
      this.setState({ detailCourse: course, activityEdit: null });
    }
    return false;
  }

  showSaveNotification(title, text) {
    this.refs.notificator.success(title, text, 3000);
  }

  showErrorNotification(title, text) {
    this.refs.notificator.error(title, text, 3000);
  }

  renderTitleLink(course) {
    if (this.props.printMode) {
      return <span>{course.title}</span>;
    }
    return (
      <ButtonUnderlined
        label={course.title}
        onClick={() => this.openCourse(course)}
        hoverEffect={false}
        noWrap={true}
      />
    );
  }

  renderMetaDataColumnHeaders() {
    let self = this;
    if (this.state.activeConfig) {
      let columns = this.state.activeConfig.map(function (c) {
        return (
          <th className="nowrap hidemobile" key={c}>
            {self.l(c)}{" "}
          </th>
        );
      });
      return columns;
    }
    return null;
  }

  renderMetaDataTableCells(course) {
    const { activeConfig } = this.state;

    if (activeConfig) {
      return activeConfig.map((configValue) => {
        const metadataField = course.metaData?.find(
          (field) => field.name === configValue,
        );

        return metadataField ? (
          <td className="hidemobile hidetablet">{metadataField.value}</td>
        ) : (
          <td className="hidemobile hidetablet">&nbsp;</td>
        );
      });
    }
    return null;
  }

  renderCustomColumnHeaders() {
    if (this.state.installationId === "cambrex") {
      return (
        <th
          className="nowrap hidemobile"
          onClick={(e) => this.sortCourses("billingAddress")}
        >
          {this.l("BillingAddress")}{" "}
          {this.state.sortByCourses === "billingAddress" && (
            <span className={this.getArrowClass.bind(this)} />
          )}
        </th>
      );
    }
    return null;
  }

  renderCustomColumnCells(course) {
    if (this.state.installationId === "cambrex") {
      return <td className="hidemobile">{course.billingAddress}</td>;
    }
    return null;
  }

  getArrowClass() {
    if (this.props.printMode) return "hidden";
    else
      return this.state.sortOrderCourses === "desc"
        ? "icon-sortarrow-down"
        : "icon-sortarrow-up";
  }

  isDeleteAllowed(courseType) {
    const { isManager } = this.props;
    const { allowUsersToCompleteCourses, allowUsersToCompleteActivities } =
      this.state;
    const normalized =
      typeof courseType === "string" ? courseType.toLowerCase() : courseType;

    if (normalized === "externalcourse" || normalized === "otheractivity") {
      if (isManager) {
        return true;
      } else {
        return (
          allowUsersToCompleteCourses === "1" ||
          allowUsersToCompleteActivities === "1"
        );
      }
    } else {
      return false;
    }
  }

  renderCertificatesTableCell(certificates) {
    return (
      <td>
        {certificates &&
          certificates.map((cert, index) => {
            let isExpired = moment(cert.expireDate).isBefore(moment());
            let certificateExpireDate = cert.expireDate
              ? moment(cert.expireDate).format(
                  config.shortDateFormat.toUpperCase(),
                )
              : this.l("noexpiredate");
            return (
              <div key={"c" + index} title={cert.certificate.title}>
                <span
                  className="icon-certificate"
                  aria-hidden="true"
                  title={cert.certificate.title}
                />
                &nbsp;
                <span className={isExpired ? "red" : ""}>
                  {certificateExpireDate}
                </span>
              </div>
            );
          })}
      </td>
    );
  }

  renderAttachmentsTableCell(course) {
    return (
      <td>
        {course.attachmentId && (
          <a
            href={
              "utils/StreamFile.aspx?type=externalcourse&param=" +
              course.id +
              "&attachmentid=" +
              course.attachmentId +
              "&q=" +
              new Date().getTime()
            }
            className="nowrap"
            target="_blank"
            rel="noreferrer noopener"
          >
            {course.fileName}
            &nbsp;&nbsp;
            <span
              className="fa fa-external-link"
              aria-hidden="true"
              title={this.l("openinnewwindow")}
            />
          </a>
        )}
      </td>
    );
  }

  renderDeleteTableCell(course) {
    const { printMode } = this.props;
    const normalizedType = this.getNormalizedCourseType(course);

    return (
      <td>
        {!printMode && this.isDeleteAllowed(normalizedType) && (
          <IconButton
            label={this.l("deleteeducation")}
            onClick={() => this.deleteActivity(course)}
            icon="icon-trash"
          />
        )}
      </td>
    );
  }

  renderTitleTableCell(course) {
    const { isReport } = this.props;
    const normalizedType = this.getNormalizedCourseType(course);

    return (
      <td>
        {this.isClickableActivityType(normalizedType) && !isReport
          ? this.renderTitleLink(course)
          : course.title}
      </td>
    );
  }

  renderCoursesTableRows(courses) {
    const { isReport } = this.props;
    const list = Array.isArray(courses) ? courses : [];

    return list.map((course, index) => {
      const normalizedType = this.getNormalizedCourseType(course);
      const renderType = isStandardActivityType(normalizedType)
        ? this.l(normalizedType)
        : course.type;

      return (
        <tr key={index + ""}>
          {this.renderTitleTableCell(course)}
          {!isReport ? (
            <>
              <td className="hidemobile">{renderType}</td>
              <td className="hidemobile">{course.startDate}</td>
              <td className="hidemobile">{course.endDate}</td>
              {this.renderCustomColumnCells(course)}
              {this.renderMetaDataTableCells(course)}
              {this.renderCertificatesTableCell(course.certificates)}
              {this.renderAttachmentsTableCell(course)}
              {this.renderDeleteTableCell(course)}
            </>
          ) : (
            <td className="nowrap">{course.endDate}</td>
          )}
        </tr>
      );
    });
  }

  renderGenericTableHeaderCell(
    column,
    printable = true,
    classNameStr = "nowrap hidemobile",
    localeString = column,
  ) {
    const { sortByCourses } = this.state;

    return (
      <th className={classNameStr} onClick={() => this.sortCourses(column)}>
        {`${this.l(localeString)} `}
        {sortByCourses === column && (
          <span
            className={`${this.getArrowClass()} ${
              !printable && "notprintable"
            }`}
          />
        )}
      </th>
    );
  }

  renderAddActivity() {
    const { activityEdit } = this.state;
    const { personalId } = this.props;

    return (
      activityEdit && (
        <AddActivity
          activity={activityEdit}
          fromEducationHistory={true}
          onRefresh={this.onRefresh.bind(this)}
          onShowSaveNotification={this.showSaveNotification.bind(this)}
          onShowErrorNotification={this.showErrorNotification.bind(this)}
          personalId={personalId}
          resetEditActivity={this.resetEditActivity.bind(this)}
          allowAttachment={true}
        />
      )
    );
  }

  renderDetailDialog() {
    const { detailCourse } = this.state;

    return (
      detailCourse && (
        <EducationHistoryDetailDialog
          course={detailCourse}
          onClose={this.resetDetailCourse.bind(this)}
        />
      )
    );
  }

  renderCoursesTable(courses) {
    const { isReport } = this.props;
    const list = Array.isArray(courses) ? courses : [];
    const coursesTableRows = this.renderCoursesTableRows(list);

    return (
      <table className={list.length > 0 ? "maindatatable" : "hidden"}>
        <thead>
          <tr>
            {!isReport ? (
              <>
                {this.renderGenericTableHeaderCell("title", false, "nowrap")}
                {this.renderGenericTableHeaderCell("type")}
                {this.renderGenericTableHeaderCell("startDate")}
                {this.renderGenericTableHeaderCell("endDate", false)}
                {this.renderMetaDataColumnHeaders()}
                {this.renderCustomColumnHeaders()}
                <th className="nowrap hidemobile">{this.l("certificate")}</th>
                {this.renderGenericTableHeaderCell("fileName")}
                <th>
                  <span className="sr-only">{this.l("deleteeducation")}</span>
                </th>
              </>
            ) : (
              <>
                {this.renderGenericTableHeaderCell(
                  "title",
                  false,
                  "nowrap",
                  "education",
                )}
                {this.renderGenericTableHeaderCell("endDate", false, "nowrap")}
              </>
            )}
          </tr>
        </thead>
        <tbody>{coursesTableRows}</tbody>
      </table>
    );
  }

  doRender() {
    if (!this.state.ready) return <div> {`${this.l("loading")}...`} </div>;

    const { isReport, printMode, isManager } = this.props;

    const {
      allowUsersToCompleteCourses,
      allowUsersToCompleteActivities,
      hideOtherActivitiesInEducationHistory,
      hideAddCompletedCoursesInEducationHistory,
    } = this.state;
    const courses = Array.isArray(this.state.courses) ? this.state.courses : [];

    const PERMISSION = { ALLOWED: "1", DISALLOWED: "0" };
    const HIDDEN = "1";

    const hideAddButton =
      (allowUsersToCompleteCourses === PERMISSION.DISALLOWED ||
        hideAddCompletedCoursesInEducationHistory === HIDDEN) &&
      (allowUsersToCompleteActivities === PERMISSION.DISALLOWED ||
        hideOtherActivitiesInEducationHistory === HIDDEN);

    const hideAddButtonCompletedManager =
      hideOtherActivitiesInEducationHistory === HIDDEN &&
      hideAddCompletedCoursesInEducationHistory === HIDDEN;

    return (
      <div className="goals">
        <Notifier ref="notificator" hideHeader={false} />

        <div
          className={
            printMode ||
            (hideAddButton && !isManager) ||
            isReport ||
            hideAddButtonCompletedManager
              ? "hidden"
              : "flex flex-end"
          }
        >
          <div>
            <SingleaddButton
              label={this.l("add")}
              onClick={this.openDialog.bind(this)}
            />
          </div>
        </div>
        <div className="maindatatable-wrapper">
          {this.renderCoursesTable(courses)}
        </div>

        {this.renderAddActivity()}
        {this.renderDetailDialog()}

        {courses.length === 0 && (
          <div>{this.l("noactivitiescompletedoradded")}</div>
        )}
      </div>
    );
  }
}
